import { Type } from "class-transformer";
import { AbstractJSONModel } from "./master-model";

export interface ISchoolClasses {
  id: number;
  school_id: number;
  class_level: number;
  class_track: string;
  description: string;
  created_at: Date;
  updated_at: Date;
  is_hidden: boolean;
}

export class SchoolClasses extends AbstractJSONModel implements ISchoolClasses {
  public id = -1;
  public school_id = -1;
  public class_level = -1;
  public class_track = "";
  public description = "";
  @Type(() => Date)
  public created_at: Date = new Date();
  @Type(() => Date)
  public updated_at: Date = new Date();
  public is_hidden = true;

  equals(other: ISchoolClasses): boolean {
    return other.id === this.id;
  }
}
